import { AnyAction } from 'redux'
import Variant from '../../elements/variant/Variant'

export interface Variant {
  name: string
  weight: number
}

export interface Experiment {
  id: number
  variants: Variant[]
}

export interface Experiments {
  [name: string]: Variant
}

const SET_VARIANT = 'SET_VARIANT'
export const setVariant = (experiment: number, variant: Variant) => ({
  type: SET_VARIANT,
  experiment,
  variant,
})

export default function experimentsReducer(
  currentState: Experiments = {},
  action: AnyAction,
): Experiments {
  switch (action.type) {
    case SET_VARIANT:
      const newState = Object.assign({}, currentState)
      newState[action.experiment] = action.variant
      return newState
    default:
      return currentState
  }
}
